import { useI18n } from "@wojo/localization";
import { Markdown, Text } from "@wojo/ui";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import utc from "dayjs/plugin/utc";
import React from "react";
import { useTripBuilder } from "../context/TripBuilderContext";
import { SectionDepartureDates } from "./SectionDepartureDates";
import { useTourPageContext } from "../../../_client/context";
import { useMapDepartureStatus } from "../hooks/use-map-departure-status";
import { useShowMarketingMessageView } from "../context/use-show-marketing-message-view";
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);

export const TripBuilderMessageViewUnavailable: React.FC = () => {
    const { gcDeparture, departure } = useTripBuilder();
    const { callToBookDpd } = useTourPageContext();
    const departureStatus = useMapDepartureStatus(departure, callToBookDpd);
    const showMarketingMessageView = useShowMarketingMessageView();
    const { productPage } = useI18n("productPage");

    if (departureStatus !== "Unavailable" || showMarketingMessageView) {
        return null;
    }

    const i18nUnavailable = productPage.tripBuilder.unavailable;
    const isDeparted = dayjs
        .utc(departure?.departureDate)
        .isSameOrBefore(dayjs.utc());
    const isSoldOut = departure && departure.nbSpotsLeft <= 0;
    const gcProfileUrl = gcDeparture?.gcProfileContent?.fullSlug
        .split("/")
        .pop();
    const isGroups = !!gcDeparture && !!gcProfileUrl;

    let heading = i18nUnavailable.heading.l();
    let description = isGroups
        ? i18nUnavailable.groupsDescription.l({
              url: `/${gcProfileUrl}`,
          })
        : i18nUnavailable.description.l();

    if (isDeparted) {
        heading = i18nUnavailable.departed.heading.l();
        description = isGroups
            ? i18nUnavailable.departed.groupsDescription.l({
                  url: `/${gcProfileUrl}`,
              })
            : i18nUnavailable.departed.description.l();
    } else if (isSoldOut) {
        heading = i18nUnavailable.soldOut.heading.l();
        description = isGroups
            ? i18nUnavailable.soldOut.groupsDescription.l({
                  url: `/${gcProfileUrl}`,
              })
            : i18nUnavailable.soldOut.description.l();
    }

    return (
        <>
            <SectionDepartureDates />
            <div style={{ padding: "var(--g-spacing-lg)" }}>
                <Text.Heading
                    order="5"
                    tag="h2"
                    style={{ marginBottom: "var(--g-spacing-md)" }}
                >
                    {heading}
                </Text.Heading>
                <Markdown markdown={description} />
            </div>
        </>
    );
};
